import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, MapPin, Clock } from 'lucide-react';
const experiences = [{
  title: 'Parque Nacional Conguillío',
  location: 'Chile',
  duration: 'Full Day',
  price: '$160.000 CLP',
  img: 'https://cdn.magicpatterns.com/uploads/3cRykNnvsmMY7ncFMgxvLF/Parque_Nacional_Conguillio.png',
  link: 'https://pub-d4ad1d836275460aa6d7fb27a925772e.r2.dev/_FULL%20DAY%20CONGUILLIO_compressed.pdf'
}, {
  title: 'Termas del Sol',
  location: 'Chile',
  duration: 'Full Day',
  price: '$250.000 CLP',
  img: 'https://cdn.magicpatterns.com/uploads/ex5b7E4eMc4pdUpfEJS3mo/Puerto_Varas.png',
  link: 'https://pub-d4ad1d836275460aa6d7fb27a925772e.r2.dev/FULL%20DAY%20TERMAS%20DEL%20SOL_compressed.pdf'
}, {
  title: 'Auroras Boreales',
  location: 'Finlandia y Noruega',
  duration: '14 Días',
  price: 'Desde $6.900.000 CLP',
  img: 'https://cdn.magicpatterns.com/uploads/uWLN2oXZXjAXbeSwu7jWtb/Auroras_Boreales.png',
  link: 'https://pub-d4ad1d836275460aa6d7fb27a925772e.r2.dev/AURORAS%20BOREALES_compressed.pdf'
}, {
  title: 'Día de los Muertos',
  location: 'Riviera Maya',
  duration: '7 Días',
  price: 'Desde $2.400.000 CLP',
  img: 'https://cdn.magicpatterns.com/uploads/4zHGD41efyUbtDTKQUuzny/Dia_de_los_Muertos.png',
  link: 'https://pub-d4ad1d836275460aa6d7fb27a925772e.r2.dev/_RIVIERA%20MAYA%20Di%CC%81A%20DE%20MUERTOS_compressed.pdf'
}, {
  title: 'Malalcahuello',
  location: 'Chile',
  duration: 'Full Day',
  price: '$170.000 CLP',
  img: 'https://cdn.magicpatterns.com/uploads/9uUPvsmtjFz9bkLmKTvUdu/Malalcahuello-NP-1-1-1-scaled.jpg',
  link: 'https://pub-d4ad1d836275460aa6d7fb27a925772e.r2.dev/FULL%20DAY%20MALALCAHUELLO_compressed.pdf'
}, {
  title: 'Carretera Austral',
  location: 'Chile',
  duration: '8 Días',
  price: 'Desde $1.650.000 CLP',
  img: 'https://cdn.magicpatterns.com/uploads/dbXtHnRzVG8rtkQsZfTD2M/Carretera_Austral.png',
  link: 'https://pub-d4ad1d836275460aa6d7fb27a925772e.r2.dev/CARRETERA%20AUSTRAL%20SUR_compressed.pdf'
}, {
  title: 'Cartagena de Indias e Isla San Andrés',
  location: 'Colombia',
  duration: '7 Días',
  price: 'Desde $2.200.000 CLP',
  img: 'https://cdn.magicpatterns.com/uploads/f7BqFZkSQvwPgua4CS35t3/COLOMBIA.jpg',
  link: 'https://pub-d4ad1d836275460aa6d7fb27a925772e.r2.dev/CARTAGENA%20DE%20INDIAS%20%26%20ISLA%20SAN%20ANDR%C3%89S_compressed.pdf'
}, {
  title: 'Tailandia',
  location: 'Sudeste Asiático',
  duration: '16 Días',
  price: '$5.990.000 CLP',
  img: 'https://images.unsplash.com/photo-1528181304800-259b08848526?q=80&w=1000&auto=format&fit=crop',
  link: 'https://pub-d4ad1d836275460aa6d7fb27a925772e.r2.dev/TAILANDIA%202026_compressed.pdf'
}, {
  title: 'Torres del Paine',
  location: 'Patagonia',
  duration: '5 Días',
  price: 'Desde $1.090.000 CLP',
  img: 'https://cdn.magicpatterns.com/uploads/ecNR1UuYVcFgxrai87QfYL/Torres_de_paine.png',
  link: 'https://pub-d4ad1d836275460aa6d7fb27a925772e.r2.dev/_TORRES%20DEL%20PAINE_compressed.pdf'
}, {
  title: 'Rapa Nui Verano',
  location: 'Isla de Pascua',
  duration: '6 Días',
  price: 'Desde $1.600.000 CLP',
  img: 'https://cdn.magicpatterns.com/uploads/rea3XJshb5o5dW5B5oGise/Rapanui_Verano.png',
  link: 'https://pub-d4ad1d836275460aa6d7fb27a925772e.r2.dev/RAPA%20NUI%20VERANO%20-%20CHILE_compressed.pdf'
}, {
  title: 'Rapa Nui Tapati',
  location: 'Isla de Pascua',
  duration: '6 Días',
  price: 'Desde $1.750.000 CLP',
  img: 'https://cdn.magicpatterns.com/uploads/hQrfb7yWcu7Cet12ubDeCK/WhatsApp_Image_2026-05-23_at_17.03.13.jpg',
  link: 'https://pub-d4ad1d836275460aa6d7fb27a925772e.r2.dev/RAPANUI%20TAPATI%202027_compressed.pdf'
}, {
  title: 'Salar de Uyuni',
  location: 'Bolivia',
  duration: '5 Días',
  price: 'Desde $820.000 CLP',
  img: 'https://cdn.magicpatterns.com/uploads/nFXaRG9VzKWFGWcqFcbjyF/Salar_de_uyuni.png',
  link: 'https://pub-d4ad1d836275460aa6d7fb27a925772e.r2.dev/SALAR%20DE%20UYUNI_compressed.pdf'
}, {
  title: 'Selva Amazónica',
  location: 'Perú',
  duration: '5 Días',
  price: 'Desde $1.450.000 CLP',
  img: 'https://cdn.magicpatterns.com/uploads/a1QrjtcDFm9w5hJ3uYRY8t/Selva_amazonica.png',
  link: 'https://pub-d4ad1d836275460aa6d7fb27a925772e.r2.dev/SELVA%20AMAZO%CC%81NICA_compressed.pdf'
}, {
  title: 'San Pedro de Atacama',
  location: 'Chile',
  duration: '5 Días',
  price: 'Desde $1.050.000 CLP',
  img: 'https://cdn.magicpatterns.com/uploads/3uqCXY183JGjAn3vCwemLD/OSD27GSXEFD3HATJBNNCGLJDLA.jpg',
  link: 'https://pub-d4ad1d836275460aa6d7fb27a925772e.r2.dev/SAN%20PEDRO%20DE%20ATACAMA_compressed.pdf'
}, {
  title: 'Rapa Nui',
  location: 'Chile',
  duration: '5 Días',
  price: 'Desde $1.350.000 CLP',
  img: 'https://cdn.magicpatterns.com/uploads/bFkAz9amU6vdbEjsBS53XT/Rapanui.jpg',
  link: 'https://pub-d4ad1d836275460aa6d7fb27a925772e.r2.dev/RAPA%20NUI%20-%20CHILE_compressed.pdf'
}, {
  title: 'Machu Picchu',
  location: 'Perú',
  duration: '6 Días',
  price: 'Desde $1.600.000 CLP',
  img: 'https://cdn.magicpatterns.com/uploads/nmGb8qF6pLLKj9mBhtYHUy/WhatsApp_Image_2026-05-23_at_16.51.35.jpg',
  link: 'https://pub-d4ad1d836275460aa6d7fb27a925772e.r2.dev/MACHU%20PICCHU_compressed.pdf'
}, {
  title: 'Riviera Maya',
  location: 'México',
  duration: '7 Días',
  price: 'Desde $2.290.000 CLP',
  img: 'https://cdn.magicpatterns.com/uploads/fZN5V8YuZa2fHQnd7iGt7M/Diseno_sin_titulo_-_2026-05-23T174832.884.png',
  link: 'https://pub-d4ad1d836275460aa6d7fb27a925772e.r2.dev/RIVIERA%20MAYA%202026_compressed.pdf'
}, {
  title: 'Chiloé',
  location: 'Chile',
  duration: '5 Días',
  price: 'Desde $1.100.000 CLP',
  img: 'https://cdn.magicpatterns.com/uploads/9pEn4jE3KCVdLcMXT4WGwt/Copia_de_Salar_de_uyuni.png',
  link: 'https://pub-d4ad1d836275460aa6d7fb27a925772e.r2.dev/CHILO%C3%89%20-%20CHILE_compressed.pdf'
}, {
  title: 'Isla Robinson Crusoe',
  location: 'Chile',
  duration: '7 Días',
  price: '$2.920.000 CLP',
  img: 'https://cdn.magicpatterns.com/uploads/s6DZeLpT1uStbT5riwKmFA/isla-robinson-crusoe.jpg',
  link: 'https://pub-d4ad1d836275460aa6d7fb27a925772e.r2.dev/ISLA%20ROBINSON%20CRUSOE%20-%20CHILE_compressed.pdf'
}, {
  title: 'Nevados de Chillán',
  location: 'Chile',
  duration: 'Full Day',
  price: '$180.000 CLP',
  img: 'https://cdn.magicpatterns.com/uploads/wDg8u3e9mDEU1AoxTVrx9p/Nevados-de-chillan-house-2.jpg',
  link: 'https://pub-d4ad1d836275460aa6d7fb27a925772e.r2.dev/FULL%20DAY%20NEVADOS%20DE%20CHILLAN_compressed.pdf'
}, {
  title: 'Mendoza',
  location: 'Argentina',
  duration: 'Full Day',
  price: '$180.000 CLP',
  img: 'https://cdn.magicpatterns.com/uploads/we1eubaL68nMPTK6JVBMKD/WhatsApp_Image_2026-06-01_at_18.40.32.jpg',
  link: 'https://pub-d4ad1d836275460aa6d7fb27a925772e.r2.dev/FULL%20DAY%20MENDOZA_compressed.pdf'
}, {
  title: 'Chañaral de Aceituno',
  location: 'Chile',
  duration: 'Full Day',
  price: '$170.000 CLP',
  img: 'https://cdn.magicpatterns.com/uploads/tUyeLqmgSUeciZaWRNZNG4/WhatsApp_Image_2026-06-01_at_18.26.44.jpg',
  link: 'https://pub-d4ad1d836275460aa6d7fb27a925772e.r2.dev/FULL%20DAY%20CHAN%CC%83ARAL%20DE%20ACEITUNO_compressed.pdf'
}, {
  title: 'Alerce Andino',
  location: 'Chile',
  duration: 'Full Day',
  price: '$180.000 CLP',
  img: 'https://cdn.magicpatterns.com/uploads/kjbSpPgtQVP3ehJAvzDrsS/alerce-amigo.jpg',
  link: 'https://pub-d4ad1d836275460aa6d7fb27a925772e.r2.dev/FULL%20DAY%20ALERCE%20ANDINO_compressed.pdf'
}];
export function ExperiencesSection() {
  return <section id="experiencias" className="py-32 md:py-40 px-6 md:px-12 lg:px-24 bg-cream" data-id="element-68">
      <div className="max-w-7xl mx-auto" data-id="element-69">
        {/* Eyebrow & Divider */}
        <div className="mb-16 md:mb-20" data-id="element-70">
          <span className="text-xs font-sans uppercase tracking-[0.3em] text-charcoal/60 block mb-4" data-id="element-71">
            — 02 / EXPERIENCIAS
          </span>
          <div className="w-full h-[1px] bg-charcoal/10 mb-12" data-id="element-72" />

          <div className="flex flex-col md:flex-row md:items-end justify-between gap-8" data-id="element-73">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 1
          }} data-id="element-74">
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif italic text-charcoal mb-4 leading-[1.1]" data-id="element-75">
                Nuestras Experiencias
              </h2>
              <p className="text-charcoal/60 font-sans text-sm md:text-base max-w-lg leading-relaxed" data-id="element-76">
                Descubre destinos cuidadosamente seleccionados donde la aventura
                y la conexión se encuentran.
              </p>
            </motion.div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16 mb-16" data-id="element-77">
          {experiences.map((exp, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.8,
          delay: idx % 3 * 0.15
        }} className="flex flex-col group cursor-pointer" data-id="element-78">
              <div className="relative w-full aspect-[4/5] rounded-2xl overflow-hidden mb-6" data-id="element-79">
                <div className="absolute inset-0 bg-black/10 group-hover:bg-black/0 transition-colors duration-500 z-10" data-id="element-80" />
                <img src={exp.img} alt={exp.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-1000 ease-out" data-id="element-81" />
                <div className="absolute top-4 right-4 z-20 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full" data-id="element-82">
                  <span className="text-sm font-sans font-medium text-charcoal" data-id="element-83">
                    {exp.price}
                  </span>
                </div>
              </div>

              <div className="flex items-center gap-4 text-xs font-sans text-charcoal/50 uppercase tracking-wider mb-3" data-id="element-84">
                <div className="flex items-center gap-1" data-id="element-85">
                  <MapPin className="w-3 h-3" data-id="element-86" /> {exp.location}
                </div>
                <div className="flex items-center gap-1" data-id="element-87">
                  <Clock className="w-3 h-3" data-id="element-88" /> {exp.duration}
                </div>
              </div>

              <h3 className="text-2xl font-serif italic text-charcoal leading-tight mb-4" data-id="element-89">
                {exp.title}
              </h3>

              {exp.link ? <a href={exp.link} target="_blank" rel="noopener noreferrer" className="flex items-center text-sm font-sans font-medium text-rose-primary group-hover:text-rose-light transition-colors mt-auto" data-id="element-90">
                  Ver más{' '}
                  <ArrowRight className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform" data-id="element-91" />
                </a> : <div className="flex items-center text-sm font-sans font-medium text-rose-primary group-hover:text-rose-light transition-colors mt-auto" data-id="element-92">
                  Ver más{' '}
                  <ArrowRight className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform" data-id="element-93" />
                </div>}
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-94">
          <a href="https://wa.me/56962140004?text=Hola%2C%20estoy%20interesada%20en%20uno%20de%20sus%20viajes." target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm font-sans uppercase tracking-wider text-charcoal hover:text-rose-primary transition-colors border-b border-charcoal/20 hover:border-rose-primary pb-1" data-id="element-95">
            Consultar con una asesora por WhatsApp{' '}
            <ArrowRight className="w-4 h-4" data-id="element-96" />
          </a>
        </motion.div>
      </div>
    </section>;
}